import { fallbackAutoGenerated } from './generated.fallbackAutoGenerated'

export const autoGeneratedNl = {
  ...fallbackAutoGenerated,
  'moneyIn.voucher.Afvigelse.title': 'Afwijking',
  'moneyIn.voucher.AggregatedPersonSpecVoucher.title':
    'Geaggregeerd persoonsspecificatieboekstuk',
  'moneyIn.voucher.AmountWithPeriod.title': 'Bedrag met periode',
  'moneyIn.voucher.AssumedMoneyInPolicySpecification.title':
    'Veronderstelde betalingsspecificatie voor polis',
  'moneyIn.voucher.AssumedPaymentInvoiceElementVoucher.title':
    'Veronderstelde betalingsfactuurregel boekstuk',
  'moneyIn.voucher.AssumedPaymentInvoiceSpecification.title':
    'Veronderstelde betalingsfactuur',
  'moneyIn.voucher.AzlPreliminaryPremiumVoucher.title':
    'Voorlopige premieboekstuk',
  'moneyIn.voucher.AzlReturnPaymentInvoiceSpecification.title':
    'Factuurspecificatie voor terugbetaling',
  'moneyIn.voucher.AzlReturnPaymentInvoiceVoucher.title':
    'Factuurboekstuk voor terugbetaling',
  'moneyIn.voucher.BeskGrad.title': 'Tewerkstellingsgraad',
  'moneyIn.voucher.BillingPaymentSpecVoucher.title':
    'Specificatieboekstuk voor inningsbetaling',
  'moneyIn.voucher.BillingRequestInvoiceSpecification.title':
    'Factuurspecificatie voor incassoverzoek',
  'moneyIn.voucher.BillingRequestSpecification.title': 'Incassospecificatie',
  'moneyIn.voucher.BillingRequestVoucher.title': 'Boekstuk voor incassoverzoek',
  'moneyIn.voucher.BillingVoucher.title': 'Inningsboekstuk',
  'moneyIn.voucher.BlobRef.title': 'Blobreferentie',
  'moneyIn.voucher.Bs601BillingVoucher.title': 'BS601-inningsboekstuk',
  'moneyIn.voucher.Bs602BillingPaymentSpecVoucher.title':
    'BS602-specificatieboekstuk voor inningsbetaling',
  'moneyIn.voucher.Bs602PaymentVoucher.title': 'BS602-betalingsboekstuk',
  'moneyIn.voucher.CancelledBillingRequestVoucher.title':
    'Boekstuk voor geannuleerd inningsverzoek',
  'moneyIn.voucher.CancelledInvoicePaymentVoucher.title':
    'Boekstuk voor geannuleerde factuurbetaling',
  'moneyIn.voucher.CommonEmploymentInformation.title':
    'Gemeenschappelijke dienstverbandgegevens',
  'moneyIn.voucher.CompanyRef.title': 'Bedrijfsreferentie',
  'moneyIn.voucher.CorporatePaymentOrigin.title':
    'Herkomst van bedrijfsbetaling',
  'moneyIn.voucher.CorporatePersonSpec.title':
    'Persoonsspecificatie voor bedrijven',
  'moneyIn.voucher.CorporateSpecSourceInformation.title':
    'Brongegevens voor werkgeversspecificatie',
  'moneyIn.voucher.CorporateSpecificationLineVoucher.title':
    'Boekstuk voor bedrijfsspecificatieregel',
  'moneyIn.voucher.DailyWage.title': 'Dagloon',
  'moneyIn.voucher.DirectDebitPaymentCancellationVoucher.title':
    'Boekstuk voor geannuleerde automatische incasso',
  'moneyIn.voucher.DirectDebitPaymentSpecVoucher.title':
    'Specificatieboekstuk voor automatische incasso',
  'moneyIn.voucher.DirectDebitPaymentVoucher.title':
    'Boekstuk voor automatische incasso',
  'moneyIn.voucher.DocumentRef.title': 'Documentreferentie',
  'moneyIn.voucher.EfakturaPaymentVoucher.title': 'E-factuurbetalingsboekstuk',
  'moneyIn.voucher.EmployeeData.title': 'Werknemersgegevens',
  'moneyIn.voucher.EmployeePremiumVoucher.title': 'Werknemerspremieboekstuk',
  'moneyIn.voucher.EmployerAgreementData.title':
    'Werkgeversovereenkomstgegevens',
  'moneyIn.voucher.EmployerInvoiceSpecification.title':
    'Werkgeversfactuurspecificatie',
  'moneyIn.voucher.EmployerSpecVoucher.title': 'Werkgeversspecificatieboekstuk',
  'moneyIn.voucher.EmploymentContributionSpec.title':
    'Bijdragespecificatie voor dienstverband',
  'moneyIn.voucher.EmploymentData.title': 'Dienstverbandgegevens',
  'moneyIn.voucher.EmploymentDataCancellation.title':
    'Annulering van dienstverbandgegevens',
  'moneyIn.voucher.EmploymentDataCancellationVoucher.title':
    'Boekstuk voor annulering van dienstverbandgegevens',
  'moneyIn.voucher.EmploymentVoucher.title': 'Dienstverbandboekstuk',
  'moneyIn.voucher.ExternalInvoiceElementVoucher.title':
    'Externe factuurregelboekstuk',
  'moneyIn.voucher.ExternalInvoiceSpecification.title':
    'Externe factuurspecificatie',
  'moneyIn.voucher.ExternalPayloadOrigin.title':
    'Herkomst van externe berichtinhoud',
  'moneyIn.voucher.ExternalPayloadSourceData.title':
    'Brongegevens van externe berichtinhoud',
  'moneyIn.voucher.ExternalPaymentLineData.title':
    'Externe betalingsregelgegevens',
  'moneyIn.voucher.IN00500Line.title': 'IN00500-regel',
  'moneyIn.voucher.IncomingValueTransferPaymentVoucher.title':
    'Betalingsboekstuk voor inkomende waardeoverdracht',
  'moneyIn.voucher.IncomingValueTransferVoucher.title':
    'Boekstuk voor inkomende waardeoverdracht',
  'moneyIn.voucher.InfoServiceFileMetrics.title':
    'InfoService-bestandsstatistieken',
  'moneyIn.voucher.InfoServiceLineVoucher.title': 'InfoService-regelboekstuk',
  'moneyIn.voucher.InfoServicePaymentVoucher.title':
    'InfoService-betalingsboekstuk',
  'moneyIn.voucher.InfoserviceCorporateSpec.title':
    'InfoService-bedrijfsspecificatie',
  'moneyIn.voucher.InstallmentPlanInvoiceElementVoucher.title':
    'Factuurregelboekstuk voor betalingsregeling',
  'moneyIn.voucher.InstallmentPlanInvoiceReference.title':
    'Factuurreferentie voor betalingsregeling',
  'moneyIn.voucher.InstallmentPlanInvoiceSpecification.title':
    'Factuurspecificatie voor betalingsregeling',
  'moneyIn.voucher.InvoiceBundlingPenaltyVoucher.title':
    'Boekstuk voor factuurbundelingskosten',
  'moneyIn.voucher.InvoiceElementVoucher.title': 'Factuurregelboekstuk',
  'moneyIn.voucher.InvoicePaymentOrigin.title': 'Herkomst van factuurbetaling',
  'moneyIn.voucher.InvoicePaymentVoucher.title': 'Factuurbetalingsboekstuk',
  'moneyIn.voucher.InvoicePenaltyVoucher.title': 'Factuurboeteboekstuk',
  'moneyIn.voucher.InvoiceSpecification.title': 'Factuurspecificatie',
  'moneyIn.voucher.LeaveInformation.title': 'Verlofgegevens',
  'moneyIn.voucher.LegalEntityRef.title': 'Referentie naar juridische entiteit',
  'moneyIn.voucher.ManualExternalInvoiceElementVoucher.title':
    'Handmatig extern factuurregelboekstuk',
  'moneyIn.voucher.ManualInvoice.title': 'Handmatige factuur',
  'moneyIn.voucher.ManualInvoiceDetail.title': 'Handmatige factuurregel',
  'moneyIn.voucher.ManualInvoiceSpecification.title':
    'Handmatige factuurspecificatie',
  'moneyIn.voucher.ManualPaymentSpecOrigin.title':
    'Herkomst van handmatige betalingsspecificatie',
  'moneyIn.voucher.ManualPaymentVoucher.title': 'Handmatig betalingsboekstuk',
  'moneyIn.voucher.MigratedInvoice.title': 'Gemigreerde factuur',
  'moneyIn.voucher.MigratedInvoiceSpecification.title':
    'Gemigreerde factuurspecificatie',
  'moneyIn.voucher.MoneyInVoucher.title': 'Betalingsboekstuk',
  'moneyIn.voucher.NaturalPerson.title': 'Natuurlijk persoon',
  'moneyIn.voucher.NetAxeptBatch.title': 'NetAxept-batch',
  'moneyIn.voucher.NetAxeptBatchData.title': 'NetAxept-batchgegevens',
  'moneyIn.voucher.NetAxeptPaymentVoucher.title': 'NetAxept-betalingsboekstuk',
  'moneyIn.voucher.NetAxeptVoucher.title': 'NetAxept-boekstuk',
  'moneyIn.voucher.NlBillingVoucher.title': 'Inningsboekstuk',
  'moneyIn.voucher.NlValueTransferStatement.title': 'Waardeoverdrachtsopgave',
  'moneyIn.voucher.NormBidrag.title': 'Normbijdrage',
  'moneyIn.voucher.OutgoingBillingSpecification.title':
    'Uitgaande inningsspecificatie',
  'moneyIn.voucher.P41AmountEntity.title': 'P41-bedrageenheid',
  'moneyIn.voucher.P41BankAccount.title': 'P41-bankrekening',
  'moneyIn.voucher.P41BankAdditionalPaymentInfo.title':
    'P41-aanvullende betalingsgegevens van bank',
  'moneyIn.voucher.P41BankDataCommon.title':
    'P41-gemeenschappelijke bankgegevens',
  'moneyIn.voucher.P41BankPALTax31.title': 'P41-PAL-belasting van bank 31',
  'moneyIn.voucher.P41BankPALTax32.title': 'P41-PAL-belasting van bank 32',
  'moneyIn.voucher.P41BankPALTax33.title': 'P41-PAL-belasting van bank 33',
  'moneyIn.voucher.P41BankPALTax34.title': 'P41-PAL-belasting van bank 34',
  'moneyIn.voucher.P41BankPaymentInformation.title':
    'P41-bankbetalingsgegevens',
  'moneyIn.voucher.P41BankPaymentRemark.title':
    'P41-opmerking bij bankbetaling',
  'moneyIn.voucher.P41BankTransferData.title': 'P41-bankoverdrachtsgegevens',
  'moneyIn.voucher.P41BankTransferData34.title':
    'P41-bankoverdrachtsgegevens 34',
  'moneyIn.voucher.P41BankTransferFromBankV2_3.title':
    'P41-overdracht vanuit bank (v2.3)',
  'moneyIn.voucher.P41BankTransferFromBankWithTax1V2_3.title':
    'P41-overdracht vanuit bank met belasting 1 (v2.3)',
  'moneyIn.voucher.P41BankTransferFromPensionV2_3.title':
    'P41-overdracht vanuit pensioen (v2.3)',
  'moneyIn.voucher.P41BankTransferFromPensionWithTax1V2_3.title':
    'P41-overdracht vanuit pensioen met belasting 1 (v2.3)',
  'moneyIn.voucher.P41BankTransferV2_3.title': 'P41-bankoverdracht (v2.3)',
  'moneyIn.voucher.P41ContactPerson.title': 'P41-contactpersoon',
  'moneyIn.voucher.P41EmbeddedDocument.title': 'P41-ingesloten document',
  'moneyIn.voucher.P41OngoingAgeSchemePayments.title':
    'P41-doorlopende betalingen voor ouderdomsspaarregeling',
  'moneyIn.voucher.P41OngoingInstalmentPensionPayments.title':
    'P41-doorlopende betalingen voor pensioen in termijnen',
  'moneyIn.voucher.P41OngoingLifetimeAnnuityPayments.title':
    'P41-doorlopende betalingen voor levenslange lijfrente',
  'moneyIn.voucher.P41OngoingPaymentsType.title':
    'P41-type doorlopende betalingen',
  'moneyIn.voucher.P41OngoingStoppingAnnuityPayments.title':
    'P41-doorlopende betalingen voor tijdelijke lijfrente',
  'moneyIn.voucher.P41PaymentAgeType.title': 'P41-type uitbetalingsleeftijd',
  'moneyIn.voucher.P41PaymentInformation.title': 'P41-betalingsgegevens',
  'moneyIn.voucher.P41PaymentSpecVoucher.title':
    'P41-betalingsspecificatieboekstuk',
  'moneyIn.voucher.P41PaymentVoucher.title': 'P41-betalingsboekstuk',
  'moneyIn.voucher.P41PensionPALTax.title': 'P41-PAL-belasting op pensioen',
  'moneyIn.voucher.P41PensionPaymentInformation.title':
    'P41-pensioenbetalingsgegevens',
  'moneyIn.voucher.P41PensionPrivateTransferV3_5.title':
    'P41-particuliere pensioenoverdracht (v3.5)',
  'moneyIn.voucher.P41PensionProfessionalTransferV3_5.title':
    'P41-zakelijke pensioenoverdracht (v3.5)',
  'moneyIn.voucher.P41PensionTransferV3_5.title':
    'P41-pensioenoverdracht (v3.5)',
  'moneyIn.voucher.P41Repurchase.title': 'P41-terugkoop',
  'moneyIn.voucher.P41SpousePension.title': 'P41-partnerpensioen',
  'moneyIn.voucher.P41SuppAmountEntity.title': 'P41-aanvullende bedrageenheid',
  'moneyIn.voucher.P41ToBankV2_3.title': 'P41-overdracht naar bank (v2.3)',
  'moneyIn.voucher.P41Transfer.title': 'P41-overdracht',
  'moneyIn.voucher.P41TrivialityAdjustmentVoucher.title':
    'P41-boekstuk voor trivialiteitscorrectie',
  'moneyIn.voucher.PaidInvoiceVoucher.title': 'Boekstuk voor betaalde factuur',
  'moneyIn.voucher.PartIdentification.title': 'Onderdeelidentificatie',
  'moneyIn.voucher.PaymentOrigin.title': 'Herkomst van betaling',
  'moneyIn.voucher.PaymentSender.title': 'Betalingsafzender',
  'moneyIn.voucher.PaymentSpecOrigin.title':
    'Herkomst van betalingsspecificatie',
  'moneyIn.voucher.PaymentSpecSubVoucher.title':
    'Deelboekstuk voor betalingsspecificatie',
  'moneyIn.voucher.PaymentSpecVoucher.title': 'Betalingsspecificatieboekstuk',
  'moneyIn.voucher.PaymentVoucher.title': 'Betalingsboekstuk',
  'moneyIn.voucher.PenaltyVoucher.title': 'Boeteboekstuk',
  'moneyIn.voucher.PensionProviderPaymentOrigin.title':
    'Herkomst van betaling door pensioenuitvoerder',
  'moneyIn.voucher.PensionTransferVoucher.title': 'Pensioenoverdrachtsboekstuk',
  'moneyIn.voucher.PersonRef.title': 'Persoonsreferentie',
  'moneyIn.voucher.PersonSpecVoucher.title': 'Persoonsspecificatieboekstuk',
  'moneyIn.voucher.PremiumCalculationPenaltyVoucher.title':
    'Boeteboekstuk voor premieberekening',
  'moneyIn.voucher.PremiumExternalInvoiceElementVoucher.title':
    'Extern premiefactuurregelboekstuk',
  'moneyIn.voucher.PremiumInvoiceDetail.title': 'Premiefactuurregel',
  'moneyIn.voucher.PrivateBillingInvoiceElementVoucher.title':
    'Factuurregelboekstuk voor particuliere inning',
  'moneyIn.voucher.PrivatePaidBillingVoucher.title':
    'Boekstuk voor betaalde particuliere inning',
  'moneyIn.voucher.PrivatePaymentOrigin.title':
    'Herkomst van particuliere betaling',
  'moneyIn.voucher.ReminderFeeVoucher.title': 'Boekstuk voor aanmaningskosten',
  'moneyIn.voucher.ReturnedPaymentVoucher.title':
    'Boekstuk voor teruggestuurde betaling',
  'moneyIn.voucher.SalaryInformation.title': 'Salarisgegevens',
  'moneyIn.voucher.SenderAccount.title': 'Rekening van afzender',
  'moneyIn.voucher.SenderAccountIban.title': 'Rekening van afzender (IBAN)',
  'moneyIn.voucher.SenderAccountOther.title': 'Andere rekening van afzender',
  'moneyIn.voucher.TelephoneNumber.title': 'Telefoonnummer',
  'moneyIn.voucher.TransitContributionOutVoucher.title':
    'Boekstuk voor uitgaande transitbijdrage',
  'moneyIn.voucher.TransitCorporateSpecificationLineVoucher.title':
    'Transitboekstuk voor bedrijfsspecificatieregel',
  'moneyIn.voucher.TwkInvoice.title': 'TWK-factuur',
  'moneyIn.voucher.TwkInvoiceSpecification.title': 'TWK-factuurspecificatie',
  'moneyIn.voucher.UnexpectedDistributedInvoicePaymentVoucher.title':
    'Boekstuk voor onverwachte verdeelde factuurbetaling',
  'moneyIn.voucher.UnexpectedInvoicePaymentVoucher.title':
    'Boekstuk voor onverwachte factuurbetaling',
  'moneyIn.voucher.UnexpectedPaymentVoucher.title':
    'Boekstuk voor onverwachte betaling',
  'moneyIn.voucher.UnrelatedPaymentVoucher.title':
    'Boekstuk voor niet-gerelateerde betaling',
  'moneyIn.voucher.UpaIncomeRelation.title': 'UPA-inkomstenverhouding',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResult.title':
    'Validatieresultaat voor UPA-inkomstenverhoudingaangifte',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResultV2.title':
    'Validatieresultaat voor UPA-inkomstenverhoudingaangifte (v2)',
  'moneyIn.voucher.UpaIncomeRelationVoucher.title':
    'UPA-inkomstenverhoudingboekstuk',
  'moneyIn.voucher.UpaIncomeRelationVoucherV2.title':
    'UPA-inkomstenverhoudingboekstuk (v2)',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucher.title':
    'Boekstuk voor intrekking van UPA-inkomstenverhouding',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucherV2.title':
    'Boekstuk voor intrekking van UPA-inkomstenverhouding (v2)',
  'moneyIn.voucher.UpaMessageValidationResult.title':
    'Validatieresultaat voor UPA-bericht',
  'moneyIn.voucher.UpaMessageValidationResultV2.title':
    'Validatieresultaat voor UPA-bericht (v2)',
  'moneyIn.voucher.UpaValidationVoucher.title': 'UPA-validatieboekstuk',
  'moneyIn.voucher.UpaVoucher.title': 'UPA-boekstuk',
  'moneyIn.voucher.UpaVoucherV2.title': 'UPA-boekstuk (v2)',
  'moneyIn.voucher.ValueTransferAutomaticPaymentVoucher.title':
    'Boekstuk voor automatische betaling bij waardeoverdracht',
  'moneyIn.voucher.ValueTransferStatement.title': 'Waardeoverdrachtsopgave',
  'moneyIn.voucher.VoluntaryContributionVoucher.title':
    'Boekstuk voor vrijwillige bijdrage',
  'moneyIn.voucher.WithdrawnContributionVoucher.title':
    'Boekstuk voor ingetrokken bijdrage',
  'moneyIn.voucher.WriteOffInvoicePaymentVoucher.title':
    'Boekstuk voor afgeschreven factuurbetaling',
  'moneyIn.voucher._id': 'ID',
  'moneyIn.voucher.absoluteAmount': 'Absoluut bedrag',
  'moneyIn.voucher.accountNumber': 'Rekeningnummer',
  'moneyIn.voucher.accruedRightHolidayAllowance':
    'Opgebouwd recht op vakantiegeld',
  'moneyIn.voucher.acqRefDataVar': 'Variabele referentie van kaartverwerker',
  'moneyIn.voucher.additionalInformation': 'Aanvullende gegevens',
  'moneyIn.voucher.additionalPaymentInfo': 'Aanvullende betalingsgegevens',
  'moneyIn.voucher.advNo': 'ADV-nummer',
  'moneyIn.voucher.afsAftNrHosModt':
    'Overeenkomstnummer van afzender bij ontvanger',
  'moneyIn.voucher.afvigelse': 'Afwijking',
  'moneyIn.voucher.afvigelseDto': 'Afwijkingsdatum',
  'moneyIn.voucher.afvigelseKod': 'Afwijkingscode',
  'moneyIn.voucher.afvigelsesBlb': 'Afwijkingsbedrag',
  'moneyIn.voucher.afvigelsesFrtflt': 'Afwijking (Frtflt)',
  'moneyIn.voucher.afvigelsesPct': 'Afwijkingspercentage',
  'moneyIn.voucher.aggregationLineId': 'Aggregatieregel-ID',
  'moneyIn.voucher.agreementId': 'Overeenkomst-ID',
  'moneyIn.voucher.agreementQualifier': 'Overeenkomstkwalificatie',
  'moneyIn.voucher.amount': 'Bedrag',
  'moneyIn.voucher.amountEntity': 'Bedrageenheid',
  'moneyIn.voucher.amountOriginal': 'Oorspronkelijk bedrag',
  'moneyIn.voucher.amountPenalties': 'Boetebedrag',
  'moneyIn.voucher.amountPenaltiesTwk': 'TWK-boetebedrag',
  'moneyIn.voucher.amountRegularPremium': 'Regulier premiebedrag',
  'moneyIn.voucher.amountSettlement': 'Verrekeningsbedrag',
  'moneyIn.voucher.amountTwkPremium': 'TWK-premiebedrag',
  'moneyIn.voucher.arbAndelBidragBlb': 'Werkgeversdeel van bijdrage',
  'moneyIn.voucher.arbAndelPensBidragPct':
    'Werkgeversdeel van pensioenbijdrage (%)',
  'moneyIn.voucher.args': 'Argumenten',
  'moneyIn.voucher.assetManagementCost': 'Vermogensbeheerkosten',
  'moneyIn.voucher.assetManagementCostOngoingAgeScheme_Bank':
    'Vermogensbeheerkosten, lopende ouderdomsspaarregeling (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode1B_Bank':
    'Vermogensbeheerkosten, belastingcode 1B (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode1and2_Bank':
    'Vermogensbeheerkosten, belastingcode 1 en 2 (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode2B_Bank':
    'Vermogensbeheerkosten, belastingcode 2B (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode3A_Bank':
    'Vermogensbeheerkosten, belastingcode 3A (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode3B_Bank':
    'Vermogensbeheerkosten, belastingcode 3B (bank)',
  'moneyIn.voucher.assetManagementCostTaxfreeAgeScheme_Bank':
    'Vermogensbeheerkosten, belastingvrije ouderdomsspaarregeling (bank)',
  'moneyIn.voucher.assumedMoneyInCoverSpecifications':
    'Veronderstelde betalingsspecificaties voor dekkingen',
  'moneyIn.voucher.assumedMoneyInId': 'Veronderstelde betaling-ID',
  'moneyIn.voucher.assumedMoneyInPolicySpecification':
    'Veronderstelde betalingsspecificatie voor polis',
  'moneyIn.voucher.assumedPaymentInvoiceSpecificationEntries':
    'Specificatieregels voor veronderstelde factuurbetalingen',
  'moneyIn.voucher.attachedTaxExemption': 'Bijgevoegde belastingvrijstelling',
  'moneyIn.voucher.availStatementFromEmployerWithId':
    'Beschikbare werkgeversopgave met ID',
  'moneyIn.voucher.bankAccountKind': 'Soort bankrekening',
  'moneyIn.voucher.bankRegistrationNumber': 'Bankregistratienummer',
  'moneyIn.voucher.baseAmount': 'Basisbedrag',
  'moneyIn.voucher.baseInvoiceId': 'Basisfactuur-ID',
  'moneyIn.voucher.batchData': 'Batchgegevens',
  'moneyIn.voucher.batchId': 'Batch-ID',
  'moneyIn.voucher.batchNumber': 'Batchnummer',
  'moneyIn.voucher.batchPaymentId': 'Batchbetaling-ID',
  'moneyIn.voucher.beskGrad': 'BeskGrad',
  'moneyIn.voucher.beskGradAnt': 'BeskGrad (Ant)',
  'moneyIn.voucher.beskGradNvn': 'BeskGrad (naam)',
  'moneyIn.voucher.beskGradStartDto': 'BeskGrad (begindatum)',
  'moneyIn.voucher.beskGradTel': 'BeskGrad (Tel)',
  'moneyIn.voucher.billingChannel': 'Betalingskanaal',
  'moneyIn.voucher.billingFrequency': 'Betalingsfrequentie',
  'moneyIn.voucher.billingLegalEntityId':
    'Gefactureerde juridische entiteit-ID',
  'moneyIn.voucher.billingRequestEntries': 'Incassoregels',
  'moneyIn.voucher.billingRequestId': 'Incassoverzoek-ID',
  'moneyIn.voucher.billingRequestSpecification': 'Incassospecificatie',
  'moneyIn.voucher.billingRequestSpecifications': 'Incassospecificaties',
  'moneyIn.voucher.billingText': 'Factureringstekst',
  'moneyIn.voucher.billingVoucher': 'Factureringsboekstuk',
  'moneyIn.voucher.birthDate': 'Geboortedatum',
  'moneyIn.voucher.blanks': 'Lege velden',
  'moneyIn.voucher.blobName': 'Blobnaam',
  'moneyIn.voucher.blobRef': 'Blobreferentie',
  'moneyIn.voucher.blockedInMoneyIn': 'Geblokkeerd in MoneyIn',
  'moneyIn.voucher.bookDate': 'Boekingsdatum',
  'moneyIn.voucher.bs602BillingType': 'BS602-factureringstype',
  'moneyIn.voucher.buildUpEmploymentTermsAmount':
    'Opgebouwd arbeidsvoorwaardenbedrag',
  'moneyIn.voucher.bundleDueDate': 'Bundelvervaldatum',
  'moneyIn.voucher.bundlePeriodFromDate': 'Begindatum bundelperiode',
  'moneyIn.voucher.calculationDate': 'Berekeningsdatum',
  'moneyIn.voucher.cancellationDate': 'Annuleringsdatum',
  'moneyIn.voucher.cancellationPaymentId': 'Annuleringsbetaling-ID',
  'moneyIn.voucher.cancellationReason': 'Reden voor annulering',
  'moneyIn.voucher.cancellations': 'Annuleringen',
  'moneyIn.voucher.cardAcptTermId': 'Betaalterminal-ID',
  'moneyIn.voucher.cardNameLogo': 'Kaartnaam en logo',
  'moneyIn.voucher.cardOrganisation': 'Kaartorganisatie',
  'moneyIn.voucher.caseNo': 'Zaaknummer',
  'moneyIn.voucher.category': 'Categorie',
  'moneyIn.voucher.cedingCompany': 'Overdragende maatschappij',
  'moneyIn.voucher.changeDate': 'Wijzigingsdatum',
  'moneyIn.voucher.code': 'Code',
  'moneyIn.voucher.codeCollectiveWorkAgreement': 'Cao-code',
  'moneyIn.voucher.codeIncidentalIncomeReduction':
    'Code incidentele inkomstenvermindering',
  'moneyIn.voucher.codeIncomeRelationType': 'Code soort inkomstenverhouding',
  'moneyIn.voucher.codeInfluenceInsuranceObligation':
    'Code invloed verzekeringsplicht',
  'moneyIn.voucher.codeLeaveType': 'Code verlofsoort',
  'moneyIn.voucher.codeNatureOfEmploymentRelationship':
    'Code aard arbeidsverhouding',
  'moneyIn.voucher.codePhaseDivision': 'Code fase-indeling',
  'moneyIn.voucher.codeProfession': 'Beroepscode',
  'moneyIn.voucher.codeReasonForTerminationOfEmployment':
    'Code reden einde dienstverband',
  'moneyIn.voucher.codeSpecialIncomeRatio':
    'Code bijzondere inkomstenverhouding',
  'moneyIn.voucher.collectiveAgreement': 'Collectieve overeenkomst',
  'moneyIn.voucher.collectiveAgreementId': 'Collectieve overeenkomst-ID',
  'moneyIn.voucher.commission': 'Provisie',
  'moneyIn.voucher.commitmentId': 'Toezegging-ID',
  'moneyIn.voucher.commitmentOwner': 'Eigenaar van de toezegging',
  'moneyIn.voucher.commitmentOwnerLegalEntityId':
    'Juridische entiteit-ID van eigenaar van de toezegging',
  'moneyIn.voucher.commonEmploymentInformation':
    'Gemeenschappelijke dienstverbandgegevens',
  'moneyIn.voucher.companyId': 'Bedrijf-ID',
  'moneyIn.voucher.component': 'Component',
  'moneyIn.voucher.contactName': 'Contactpersoon',
  'moneyIn.voucher.contactPhoneNo': 'Telefoonnummer contactpersoon',
  'moneyIn.voucher.contractHoursPerWeek': 'Contracturen per week',
  'moneyIn.voucher.contributingElements': 'Bijdrage-elementen',
  'moneyIn.voucher.contributionCode': 'Bijdragecode',
  'moneyIn.voucher.contributionId': 'Bijdrage-ID',
  'moneyIn.voucher.contributionOptionality': 'Vrijwillig/Verplicht',
  'moneyIn.voucher.contributionPartId': 'Bijdragedeel-ID',
  'moneyIn.voucher.contributionParts': 'Bijdrageonderdelen',
  'moneyIn.voucher.contributionVouchersRefs':
    'Referenties naar bijdrageboekstukken',
  'moneyIn.voucher.corporatePersonSpec': 'Persoonsspecificatie van werkgever',
  'moneyIn.voucher.corporateSpecSourceInformation':
    'Brongegevens voor werkgeversspecificatie',
  'moneyIn.voucher.corporateSpecificationLineVouchers':
    'Boekstukken voor specificatieregels van werkgever',
  'moneyIn.voucher.countingIndication': 'Teller',
  'moneyIn.voucher.cover': 'Dekking',
  'moneyIn.voucher.coverDescription': 'Dekkingsomschrijving',
  'moneyIn.voucher.coverInternalTemplateId': 'Interne dekkingssjabloon-ID',
  'moneyIn.voucher.coverPeriodEnd': 'Einddatum dekkingsperiode',
  'moneyIn.voucher.coverPeriodStart': 'Begindatum dekkingsperiode',
  'moneyIn.voucher.creationStamp': 'Aanmaaktijd',
  'moneyIn.voucher.creationTime': 'Aanmaaktijdstip',
  'moneyIn.voucher.creditPaymentIndicator': 'Indicatie creditbetaling',
  'moneyIn.voucher.creditorName': 'Naam crediteur',
  'moneyIn.voucher.currency': 'Valuta',
  'moneyIn.voucher.currencyOriginal': 'Oorspronkelijke valuta',
  'moneyIn.voucher.currencySettl': 'Verrekeningsvaluta',
  'moneyIn.voucher.custRefNo': 'Klantreferentienummer',
  'moneyIn.voucher.customerCPR': 'CPR-nummer van klant',
  'moneyIn.voucher.dailyWage': 'Dagloon',
  'moneyIn.voucher.dateTimeTrn': 'Transactietijdstip',
  'moneyIn.voucher.dateTimeUpaFileCreation': 'Aanmaaktijdstip UPA-bestand',
  'moneyIn.voucher.dateTimeUpaFileReceival': 'Ontvangsttijdstip UPA-bestand',
  'moneyIn.voucher.daysWorked': 'Gewerkte dagen',
  'moneyIn.voucher.dbCrCard': 'Debet- of creditcard',
  'moneyIn.voucher.dbaName': 'DBA-naam',
  'moneyIn.voucher.dccAmount': 'DCC-bedrag',
  'moneyIn.voucher.dccCurrency': 'DCC-valuta',
  'moneyIn.voucher.debtorAccountNumber': 'Rekeningnummer van debiteur',
  'moneyIn.voucher.debtorCustomerNo': 'Klantnummer van debiteur',
  'moneyIn.voucher.debtorName': 'Naam debiteur',
  'moneyIn.voucher.declarationLineId': 'Aangifteregel-ID',
  'moneyIn.voucher.declaredIncomeRelationIds':
    'Aangegeven inkomstenverhouding-ID’s',
  'moneyIn.voucher.defaultReceivingCompanyId':
    'Standaard ontvangende maatschappij-ID',
  'moneyIn.voucher.deliveryDate': 'Leveringsdatum',
  'moneyIn.voucher.deliveryNumber': 'Leveringsnummer',
  'moneyIn.voucher.description': 'Omschrijving',
  'moneyIn.voucher.directDebitType': 'Type automatische incasso',
  'moneyIn.voucher.disableSpecificValidations':
    'Specifieke validaties uitschakelen',
  'moneyIn.voucher.dlSeNr': 'DL SE-nummer',
  'moneyIn.voucher.docEncodedFileContent': 'Gecodeerde documentinhoud',
  'moneyIn.voucher.docFileSize': 'Bestandsgrootte van document',
  'moneyIn.voucher.docFilename': 'Bestandsnaam van document',
  'moneyIn.voucher.docFilenameExtention': 'Bestandsextensie van document',
  'moneyIn.voucher.docMimeType': 'MIME-type van document',
  'moneyIn.voucher.documentFunction': 'Documentfunctie',
  'moneyIn.voucher.dueDate': 'Vervaldatum',
  'moneyIn.voucher.earliestRetirementAge': 'Vroegste pensioenleeftijd',
  'moneyIn.voucher.ediReference': 'EDI-referentie',
  'moneyIn.voucher.employeeContributionMandatory':
    'Verplichte werknemersbijdrage',
  'moneyIn.voucher.employeeContributionOptional':
    'Vrijwillige werknemersbijdrage',
  'moneyIn.voucher.employeeContributionOptionalWOPExemption':
    'Vrijwillige werknemersbijdrage met WOP-vrijstelling',
  'moneyIn.voucher.employeeData': 'Werknemersgegevens',
  'moneyIn.voucher.employeeId': 'Werknemer-ID',
  'moneyIn.voucher.employerAgreementData': 'Werkgeversovereenkomstgegevens',
  'moneyIn.voucher.employerAgreementId': 'Werkgeversovereenkomst-ID',
  'moneyIn.voucher.employerAgreementPolicyKey':
    'Poliskenmerk van werkgeversovereenkomst',
  'moneyIn.voucher.employerCertification': 'Werkgeversverklaring',
  'moneyIn.voucher.employerContribution': 'Werkgeversbijdrage',
  'moneyIn.voucher.employerContributionPercentage': 'Werkgeversbijdrage (%)',
  'moneyIn.voucher.employerId': 'Werkgevers-ID',
  'moneyIn.voucher.employerRef': 'Werkgeversreferentie',
  'moneyIn.voucher.employerSpecId': 'Werkgeversspecificatie-ID',
  'moneyIn.voucher.employingCompany': 'Werkgever',
  'moneyIn.voucher.employmentCancelled': 'Dienstverband geannuleerd',
  'moneyIn.voucher.employmentContractforIndefinitePeriod':
    'Arbeidsovereenkomst voor onbepaalde tijd',
  'moneyIn.voucher.employmentData': 'Dienstverbandgegevens',
  'moneyIn.voucher.employmentDataCancellation':
    'Annulering van dienstverbandgegevens',
  'moneyIn.voucher.employmentEnd': 'Einde dienstverband',
  'moneyIn.voucher.employmentId': 'Werkgevernummer',
  'moneyIn.voucher.employmentName': 'Naam dienstverband',
  'moneyIn.voucher.employmentStart': 'Begin dienstverband',
  'moneyIn.voucher.employmentType': 'Dienstverbandtype',
  'moneyIn.voucher.endDate': 'Einddatum',
  'moneyIn.voucher.endToEndId': 'End-to-end-ID',
  'moneyIn.voucher.endingPension': 'Eindigend pensioen',
  'moneyIn.voucher.entryType': 'Boekingstype',
  'moneyIn.voucher.errorCodes': 'Foutcodes',
  'moneyIn.voucher.errors': 'Fouten',
  'moneyIn.voucher.exPartnerValue': 'Waarde ex-partner',
  'moneyIn.voucher.externalEmploymentId': 'Extern dienstverband-ID',
  'moneyIn.voucher.externalPayloadKey': 'Extern gegevenskenmerk',
  'moneyIn.voucher.externalPayloadRegistrationRef':
    'Externe gegevensregistratiereferentie',
  'moneyIn.voucher.externalPayloadSourceData':
    'Brongegevens voor externe gegevens',
  'moneyIn.voucher.externalPayloadType': 'Extern gegevenstype',
  'moneyIn.voucher.externalPaymentId': 'Externe betaling-ID',
  'moneyIn.voucher.externalPaymentLineData': 'Externe betalingsregelgegevens',
  'moneyIn.voucher.externalRef': 'Externe referentie',
  'moneyIn.voucher.externalTransferId': 'Externe overdrachts-ID',
  'moneyIn.voucher.favourInformation': 'Begunstigingsgegevens',
  'moneyIn.voucher.fees': 'Kosten',
  'moneyIn.voucher.fkMedlemsNr': 'FK-lidnummer',
  'moneyIn.voucher.formerEmployer': 'Voormalige werkgever',
  'moneyIn.voucher.fromDate': 'Van datum',
  'moneyIn.voucher.fromDueDate': 'Vanaf vervaldatum',
  'moneyIn.voucher.fullSalaryInPeriod': 'Volledig salaris in periode',
  'moneyIn.voucher.generationScheme': 'Generatieregeling',
  'moneyIn.voucher.grossHourlyWage': 'Bruto uurloon',
  'moneyIn.voucher.grossPayment': 'Brutobetaling',
  'moneyIn.voucher.grossSalary': 'Brutosalaris',
  'moneyIn.voucher.handlingFee': 'Administratiekosten',
  'moneyIn.voucher.holidayAllowance': 'Vakantiegeld',
  'moneyIn.voucher.hoursOfLeave': 'Verlofuren',
  'moneyIn.voucher.id': 'ID',
  'moneyIn.voucher.identityQualifier': 'Identiteitskwalificatie',
  'moneyIn.voucher.identityValue': 'Identiteitswaarde',
  'moneyIn.voucher.incomePeriods': 'Inkomstenperioden',
  'moneyIn.voucher.incomeRelationEndDate': 'Einddatum inkomstenverhouding',
  'moneyIn.voucher.incomeRelationId': 'Inkomstenverhouding-ID',
  'moneyIn.voucher.incomeRelationStartDate': 'Begindatum inkomstenverhouding',
  'moneyIn.voucher.incurredBundlingPenaltyIds':
    "ID's van opgelegde bundelingskosten",
  'moneyIn.voucher.indicationEndOfParticipation': 'Indicatie einde deelname',
  'moneyIn.voucher.infoServiceFileMetrics': 'InfoService-bestandsstatistieken',
  'moneyIn.voucher.infoType': 'Informatietype',
  'moneyIn.voucher.infotypeKod': 'Informatietypecode',
  'moneyIn.voucher.inputDate': 'Invoerdatum',
  'moneyIn.voucher.installmentPlanInvoiceReference':
    'Factuurreferentie van betalingsregeling',
  'moneyIn.voucher.installmentPlanInvoiceReferences':
    'Factuurreferenties van betalingsregeling',
  'moneyIn.voucher.installmentSpecifications': 'Termijnspecificaties',
  'moneyIn.voucher.insuredLegalEntityId':
    'Juridische entiteit-ID van verzekerde',
  'moneyIn.voucher.integrationName': 'Integratienaam',
  'moneyIn.voucher.interestAmount_Bank': 'Rentebedrag (bank)',
  'moneyIn.voucher.interestPeriodDaysCount': 'Aantal dagen in renteperiode',
  'moneyIn.voucher.interestRate': 'Rentepercentage',
  'moneyIn.voucher.interestStartDate': 'Begindatum rente',
  'moneyIn.voucher.interestStopDate': 'Einddatum rente',
  'moneyIn.voucher.internalReferenceToCustomerPolicy':
    'Interne referentie naar klantpolis',
  'moneyIn.voucher.invoiceBundlingPenaltyType': 'Type factuurbundelingskosten',
  'moneyIn.voucher.invoiceDate': 'Factuurdatum',
  'moneyIn.voucher.invoiceDetails': 'Factuurregels',
  'moneyIn.voucher.invoiceId': 'Factuur-ID',
  'moneyIn.voucher.invoicePayerType': 'Type factuurbetaler',
  'moneyIn.voucher.invoicePeriodEndDate': 'Einddatum factuurperiode',
  'moneyIn.voucher.invoicePeriodStartDate': 'Begindatum factuurperiode',
  'moneyIn.voucher.invoiceSourceRef': 'Factuurbronreferentie',
  'moneyIn.voucher.invoiceSpecification': 'Factuurspecificatie',
  'moneyIn.voucher.invoiceStrategyOperationId': 'Factuurstrategieoperatie-ID',
  'moneyIn.voucher.invoiceType': 'Factuurtype',
  'moneyIn.voucher.irregularitySurcharge': 'Onregelmatigheidstoeslag',
  'moneyIn.voucher.isContributionAfterEmploymentEnd':
    'Bijdrage na einde dienstverband',
  'moneyIn.voucher.isCustomerPALTaxPayer': 'Klant is PAL-belastingplichtig',
  'moneyIn.voucher.isManualTransfer': 'Handmatige overdracht',
  'moneyIn.voucher.isPremiumAfterEmploymentEnd':
    'Premie na einde dienstverband',
  'moneyIn.voucher.issuerCountry': 'Land van uitgever',
  'moneyIn.voucher.jobAgreementRuleJoined':
    'Aangesloten arbeidsovereenkomstregel',
  'moneyIn.voucher.jobDescription': 'Functieomschrijving',
  'moneyIn.voucher.keptWidowsPensionRight': 'Behouden recht op weduwenpensioen',
  'moneyIn.voucher.key': 'Sleutel',
  'moneyIn.voucher.kundNrHosAfs': 'Klantnummer bij afzender',
  'moneyIn.voucher.kundNrHosModt': 'Klantnummer bij ontvanger',
  'moneyIn.voucher.kundStartDato': 'Begindatum van klant',
  'moneyIn.voucher.labourAgreement': 'Arbeidsovereenkomst',
  'moneyIn.voucher.lastPayment': 'Laatste betaling',
  'moneyIn.voucher.latestContributionPaymentBegin':
    'Begindatum van laatste bijdragebetaling',
  'moneyIn.voucher.latestContributionPaymentEnd':
    'Einddatum van laatste bijdragebetaling',
  'moneyIn.voucher.latestPayment': 'Meest recente betaling',
  'moneyIn.voucher.leaveCoverage': 'Verlofdekking',
  'moneyIn.voucher.leaveHoursInTimeSlot': 'Verlofuren in tijdvak',
  'moneyIn.voucher.leaveInformation': 'Verlofgegevens',
  'moneyIn.voucher.leavePercentage': 'Verlofpercentage',
  'moneyIn.voucher.leaves': 'Verlofperioden',
  'moneyIn.voucher.levDto': 'Leveringsdatum',
  'moneyIn.voucher.levNr': 'Leveringsnummer',
  'moneyIn.voucher.limitedWidowsPensionDate': 'Datum beperkt weduwenpensioen',
  'moneyIn.voucher.lonTrinNr': 'Nummer van salarisschaal',
  'moneyIn.voucher.lonTrinStartDto': 'Begindatum van salarisschaal',
  'moneyIn.voucher.mandateId': 'Machtiging-ID',
  'moneyIn.voucher.mandateIdentification': 'Machtigingsidentificatie',
  'moneyIn.voucher.mandateSignatureDate': 'Ondertekeningsdatum van machtiging',
  'moneyIn.voucher.manual': 'Handmatig',
  'moneyIn.voucher.manualInvoice': 'Handmatige factuur',
  'moneyIn.voucher.manualInvoiceDetail': 'Handmatige factuurregel',
  'moneyIn.voucher.manualInvoiceType': 'Handmatig factuurtype',
  'moneyIn.voucher.maritalValue': 'Huwelijkswaarde',
  'moneyIn.voucher.merchantId': 'Handelaar-ID',
  'moneyIn.voucher.merchantNo': 'Handelaarnummer',
  'moneyIn.voucher.message': 'Bericht',
  'moneyIn.voucher.messageId': 'Bericht-ID',
  'moneyIn.voucher.messageReasonCodTxt': 'Tekst van reden voor bericht',
  'moneyIn.voucher.messageText': 'Berichttekst',
  'moneyIn.voucher.messageTypeId': 'Berichttype-ID',
  'moneyIn.voucher.messageValidationResult': 'Validatieresultaat voor bericht',
  'moneyIn.voucher.migratedInvoice': 'Gemigreerde factuur',
  'moneyIn.voucher.modtAfdNr': 'Afdelingsnummer van ontvanger',
  'moneyIn.voucher.modtPbsNr': 'PBS-nummer van ontvanger',
  'moneyIn.voucher.multilangTxtShrt': 'Korte meertalige tekst',
  'moneyIn.voucher.naturalPerson': 'Natuurlijk persoon',
  'moneyIn.voucher.negativeUnusedPALTax': 'Ongebruikte negatieve PAL-belasting',
  'moneyIn.voucher.netAmountPaid': 'Betaald nettobedrag',
  'moneyIn.voucher.netAxeptBatch': 'NetAxept-batch',
  'moneyIn.voucher.netsTransId': 'Nets-transactie-ID',
  'moneyIn.voucher.newSalaryDate': 'Datum van nieuw salaris',
  'moneyIn.voucher.nlPremiumComponents': 'Premiecomponenten',
  'moneyIn.voucher.nlValueTransferPartnerStatements':
    'Partneropgaven voor waardeoverdracht',
  'moneyIn.voucher.noOfContributionsWithPeriodStartAtOrAfterPaymentDate':
    'Aantal bijdragen met periodebegin op of na betaaldatum',
  'moneyIn.voucher.noOfContributionsWithPeriodStartBeforePaymentDate':
    'Aantal bijdragen met periodebegin vóór betaaldatum',
  'moneyIn.voucher.noOfEmployerToEmployeeContributionBlocks':
    'Aantal bijdrageblokken van werkgever naar werknemer',
  'moneyIn.voucher.noOfEmployers': 'Aantal werkgevers',
  'moneyIn.voucher.noOfRecords': 'Aantal records',
  'moneyIn.voucher.noOfRegulationsWithEarlyPeriodStart':
    'Aantal aanpassingen met vroeg periodebegin',
  'moneyIn.voucher.nominalAnnualFullTimeSalary':
    'Nominaal jaarlijks voltijdsalaris',
  'moneyIn.voucher.nominalPartTimePercentage': 'Nominaal deeltijdpercentage',
  'moneyIn.voucher.normBidrag': 'Standaardbijdrage',
  'moneyIn.voucher.normBidragBlb': 'Standaardbijdragebedrag',
  'moneyIn.voucher.normBidragStartDto': 'Begindatum van standaardbijdrage',
  'moneyIn.voucher.normHoursInPeriod': 'Normuren in periode',
  'moneyIn.voucher.normHoursInPeriodLeave':
    'Normuren tijdens verlof in periode',
  'moneyIn.voucher.normHoursPerWeek': 'Normuren per week',
  'moneyIn.voucher.normHoursWeekly': 'Normuren per week',
  'moneyIn.voucher.numRecs': 'Aantal records',
  'moneyIn.voucher.numberOfInsured': 'Aantal verzekerden',
  'moneyIn.voucher.numberOfPaidHours': 'Aantal betaalde uren',
  'moneyIn.voucher.numberOfTrans': 'Aantal transacties',
  'moneyIn.voucher.numberOfUnits': 'Aantal eenheden',
  'moneyIn.voucher.onCallAgreementIndication': 'Indicatie oproepovereenkomst',
  'moneyIn.voucher.ongoingAgeScheme': 'Lopende ouderdomsspaarregeling',
  'moneyIn.voucher.ongoingInstalmentPensionPayments':
    'Lopende termijnpensioenuitkeringen',
  'moneyIn.voucher.ongoingStoppingAnnuityPayments':
    'Lopende uitkeringen van tijdelijke lijfrente',
  'moneyIn.voucher.origDateTimeTrn': 'Oorspronkelijk transactietijdstip',
  'moneyIn.voucher.originId': 'Herkomst-ID',
  'moneyIn.voucher.originType': 'Herkomsttype',
  'moneyIn.voucher.originVoucherRef': 'Referentie naar herkomstboekstuk',
  'moneyIn.voucher.originalAmount': 'Oorspronkelijk bedrag',
  'moneyIn.voucher.originalDueDate': 'Oorspronkelijke vervaldatum',
  'moneyIn.voucher.originalPaymentDate': 'Oorspronkelijke betaaldatum',
  'moneyIn.voucher.originalPostingId': 'Oorspronkelijke boekings-ID',
  'moneyIn.voucher.originalRef': 'Oorspronkelijke referentie',
  'moneyIn.voucher.outgoingBillingSpecification':
    'Uitgaande factureringsspecificatie',
  'moneyIn.voucher.outstandingAmount': 'Openstaand bedrag',
  'moneyIn.voucher.overenskomstnr': 'Arbeidsovereenkomstnummer',
  'moneyIn.voucher.ownedRecords': 'Eigen records',
  'moneyIn.voucher.ownerId': 'Persoon-ID',
  'moneyIn.voucher.p41AmountItems': 'P41-bedragposten',
  'moneyIn.voucher.p41BankAccount': 'P41-bankrekening',
  'moneyIn.voucher.p41BankDataCommon': 'P41-gemeenschappelijke bankgegevens',
  'moneyIn.voucher.p41BankPaymentInformation': 'P41-bankbetalingsgegevens',
  'moneyIn.voucher.p41ContactPerson': 'P41-contactpersoon',
  'moneyIn.voucher.p41InterestCalculations': 'P41-renteberekeningen',
  'moneyIn.voucher.p41OngoingAgeSchemePayments':
    'P41-lopende uitkeringen van ouderdomsspaarregeling',
  'moneyIn.voucher.p41OngoingInstalmentPensionPayments':
    'P41-lopende termijnpensioenuitkeringen',
  'moneyIn.voucher.p41OngoingLifetimeAnnuityPayments':
    'P41-lopende uitkeringen van levenslange lijfrente',
  'moneyIn.voucher.p41OngoingStoppingAnnuityPayments':
    'P41-lopende uitkeringen van tijdelijke lijfrente',
  'moneyIn.voucher.p41PaymentAgeType': 'P41-uitkeringsleeftijdstype',
  'moneyIn.voucher.p41PaymentFrequency': 'P41-uitkeringsfrequentie',
  'moneyIn.voucher.p41PaymentInformation': 'P41-betalingsgegevens',
  'moneyIn.voucher.p41PaymentSpecVoucherRef':
    'P41-referentie naar betalingsspecificatieboekstuk',
  'moneyIn.voucher.p41PensionPALTax': 'P41-pensioen-PAL-belasting',
  'moneyIn.voucher.p41PensionPaymentInformation':
    'P41-pensioenbetalingsgegevens',
  'moneyIn.voucher.p41PensionTransferDatas': 'P41-pensioenoverdrachtsgegevens',
  'moneyIn.voucher.p41TaxCode': 'P41-belastingcode',
  'moneyIn.voucher.p41TaxPeriode': 'P41-belastingperiode',
  'moneyIn.voucher.p41Transfer': 'P41-overdracht',
  'moneyIn.voucher.pALTaxPayedOngoingAgeScheme_Bank':
    'Betaalde PAL-belasting, lopende ouderdomsspaarregeling (bank)',
  'moneyIn.voucher.paidHoursInTimeSlot': 'Betaalde uren in tijdvak',
  'moneyIn.voucher.palTax': 'PAL-belasting',
  'moneyIn.voucher.palTax32Period': 'PAL-belastingperiode (§ 32)',
  'moneyIn.voucher.palTaxExemptionDate': 'Datum van PAL-belastingvrijstelling',
  'moneyIn.voucher.palTaxPeriod': 'PAL-belastingperiode',
  'moneyIn.voucher.palTaxPeriodPayed': 'Betaalde PAL-belasting voor periode',
  'moneyIn.voucher.palTaxPeriodUnusedNegative':
    'Onbenutte negatieve PAL-belasting voor periode',
  'moneyIn.voucher.palTaxPeriodYear': 'Jaar PAL-belastingperiode',
  'moneyIn.voucher.panVar': 'PAN-variant',
  'moneyIn.voucher.parentPaymentId': 'Bovenliggende betaling-ID',
  'moneyIn.voucher.partialInterestAmount_Bank':
    'Gedeeltelijk rentebedrag (bank)',
  'moneyIn.voucher.partialPaymentTotal_Bank': 'Totaal deelbetaling (bank)',
  'moneyIn.voucher.partialReceiver': 'Gedeeltelijke ontvanger',
  'moneyIn.voucher.partialSender': 'Gedeeltelijke afzender',
  'moneyIn.voucher.partialTransferAgeSchemeAmount':
    'Gedeeltelijke overdracht van ouderdomsspaarregeling, bedrag',
  'moneyIn.voucher.partialTransferAgeSchemeTaxFree':
    'Gedeeltelijke overdracht van belastingvrije ouderdomsspaarregeling',
  'moneyIn.voucher.partialTransferAgeSchemeTaxfree':
    'Gedeeltelijke overdracht van belastingvrije ouderdomsspaarregeling',
  'moneyIn.voucher.partialTransferAmount': 'Gedeeltelijk overdrachtsbedrag',
  'moneyIn.voucher.partialTransferLifeTimeAnnuity':
    'Gedeeltelijke overdracht van levenslange lijfrente',
  'moneyIn.voucher.partialTransferLifetimeAnnuity':
    'Gedeeltelijke overdracht van levenslange lijfrente',
  'moneyIn.voucher.partialTransferTaxCode1':
    'Gedeeltelijke overdracht, belastingcode 1',
  'moneyIn.voucher.partialTransferTaxCode1Amount':
    'Gedeeltelijk overdrachtsbedrag, belastingcode 1',
  'moneyIn.voucher.partialTransferTaxCode2':
    'Gedeeltelijke overdracht, belastingcode 2',
  'moneyIn.voucher.partialTransferTaxCode2Amount':
    'Gedeeltelijk overdrachtsbedrag, belastingcode 2',
  'moneyIn.voucher.partialTransferTaxCode3':
    'Gedeeltelijke overdracht, belastingcode 3',
  'moneyIn.voucher.partialTransferTaxCode3Amount':
    'Gedeeltelijk overdrachtsbedrag, belastingcode 3',
  'moneyIn.voucher.participant': 'Deelnemer',
  'moneyIn.voucher.participantId': 'Deelnemer-ID',
  'moneyIn.voucher.parttimePct': 'Deeltijdpercentage',
  'moneyIn.voucher.parttimePercentage': 'Deeltijdpercentage',
  'moneyIn.voucher.payInCash': 'Contante betaling',
  'moneyIn.voucher.payableId': 'Uitbetaling-ID',
  'moneyIn.voucher.payer': 'Betaler',
  'moneyIn.voucher.payerId': 'Betaler-ID',
  'moneyIn.voucher.payerLegalEntityId': 'Juridische entiteit-ID van betaler',
  'moneyIn.voucher.payerRef': 'Betalersreferentie',
  'moneyIn.voucher.payingCompany': 'Betalend bedrijf',
  'moneyIn.voucher.payment': 'Betaling',
  'moneyIn.voucher.paymentAge': 'Uitbetalingsleeftijd',
  'moneyIn.voucher.paymentBasis': 'Betalingsgrondslag',
  'moneyIn.voucher.paymentDate': 'Betaaldatum',
  'moneyIn.voucher.paymentEndDate': 'Einddatum van betaling',
  'moneyIn.voucher.paymentEntryRef': 'Betalingspostreferentie',
  'moneyIn.voucher.paymentFrequency': 'Betalingsfrequentie',
  'moneyIn.voucher.paymentId': 'Betaling-ID',
  'moneyIn.voucher.paymentInterest': 'Betalingsrente',
  'moneyIn.voucher.paymentMethod': 'Betalingsmethode',
  'moneyIn.voucher.paymentOrigin': 'Herkomst van betaling',
  'moneyIn.voucher.paymentPeriodEnd': 'Einde betalingsperiode',
  'moneyIn.voucher.paymentPeriodFrom': 'Betalingsperiode vanaf',
  'moneyIn.voucher.paymentPeriodStart': 'Begin betalingsperiode',
  'moneyIn.voucher.paymentPeriodTo': 'Betalingsperiode tot',
  'moneyIn.voucher.paymentReceiverType': 'Type betalingsontvanger',
  'moneyIn.voucher.paymentReferences': 'Betalingsreferenties',
  'moneyIn.voucher.paymentRemark': 'Betalingsopmerking',
  'moneyIn.voucher.paymentSender': 'Betalingsafzender',
  'moneyIn.voucher.paymentSpecOrigin': 'Herkomst van betalingsspecificatie',
  'moneyIn.voucher.paymentSpecVoucherRef':
    'Referentie naar betalingsspecificatieboekstuk',
  'moneyIn.voucher.paymentStartDate': 'Begindatum van betaling',
  'moneyIn.voucher.paymentTotal': 'Betaling totaal',
  'moneyIn.voucher.paymentType': 'Type betaling',
  'moneyIn.voucher.paymentWithoutInterest': 'Betaling zonder rente',
  'moneyIn.voucher.paymentWithoutPALandInterest':
    'Betaling zonder PAL-belasting en rente',
  'moneyIn.voucher.pblLimit': 'PBL-limiet',
  'moneyIn.voucher.pekoInvoiceDetails': 'PEKO-factuurregels',
  'moneyIn.voucher.penaltyId': 'Kosten-ID',
  'moneyIn.voucher.pensAlderKod': 'Pensioenleeftijdscode',
  'moneyIn.voucher.pensBidragPct': 'Pensioenbijdrage (%)',
  'moneyIn.voucher.pensBidragPctStartDto':
    'Begindatum van pensioenbijdragepercentage',
  'moneyIn.voucher.pensType': 'Pensioentype',
  'moneyIn.voucher.pensionAccountToTransfer': 'Over te dragen pensioenrekening',
  'moneyIn.voucher.pensionScheme': 'Pensioenregeling',
  'moneyIn.voucher.pensionableSalary': 'Pensioengevend salaris',
  'moneyIn.voucher.percentLeave': 'Verlofpercentage',
  'moneyIn.voucher.percentage': 'Percentage',
  'moneyIn.voucher.period': 'Periode',
  'moneyIn.voucher.periodEnd': 'Einddatum periode',
  'moneyIn.voucher.periodFullSalaryLeave':
    'Periode met volledig salaris tijdens verlof',
  'moneyIn.voucher.periodNonStructuralSalary':
    'Niet-structureel salaris in periode',
  'moneyIn.voucher.periodSalary': 'Salaris in periode',
  'moneyIn.voucher.periodStart': 'Begindatum periode',
  'moneyIn.voucher.personDataValidationStatus':
    'Validatiestatus persoonsgegevens',
  'moneyIn.voucher.personId': 'Persoons-ID',
  'moneyIn.voucher.personRef': 'Persoonsreferentie',
  'moneyIn.voucher.personSpecVouchersForRemoval':
    'Te verwijderen persoonsspecificatieboekstukken',
  'moneyIn.voucher.personnelNumber': 'Personeelsnummer',
  'moneyIn.voucher.policyDescription': 'Polisbeschrijving',
  'moneyIn.voucher.policyHolder': 'Verzekeringnemer',
  'moneyIn.voucher.policyInternalTemplateId': 'Interne sjabloon-ID van polis',
  'moneyIn.voucher.policyKey': 'Polisnummer',
  'moneyIn.voucher.policyNumber': 'Polisnummer',
  'moneyIn.voucher.policyToTransfer': 'Over te dragen polis',
  'moneyIn.voucher.postingText': 'Boekingstekst',
  'moneyIn.voucher.postingType': 'Type boeking',
  'moneyIn.voucher.premiumBase': 'Premiegrondslag',
  'moneyIn.voucher.premiumBasis': 'Premieberekeningsgrondslag',
  'moneyIn.voucher.premiumEmployee': 'Werknemerspremie',
  'moneyIn.voucher.premiumFromDueDate': 'Premie vanaf vervaldatum',
  'moneyIn.voucher.premiumInvoiceDetail': 'Premiefactuurregel',
  'moneyIn.voucher.premiumInvoiceDetails': 'Premiefactuurregels',
  'moneyIn.voucher.premiumTotal': 'Totale premie',
  'moneyIn.voucher.previousInvoiceIds': "Vorige factuur-ID's",
  'moneyIn.voucher.priority': 'Prioriteit',
  'moneyIn.voucher.processId': 'Proces-ID',
  'moneyIn.voucher.processingPeriodStart': 'Begin verwerkingsperiode',
  'moneyIn.voucher.providerCVR': 'CVR-nummer van aanbieder',
  'moneyIn.voucher.publicLawAppointmentForIndefinitePeriod':
    'Publiekrechtelijke aanstelling voor onbepaalde tijd',
  'moneyIn.voucher.rawLine': 'Onbewerkte regel',
  'moneyIn.voucher.rec1Reserve1Txt': 'Record 1, reserveveld 1',
  'moneyIn.voucher.rec3Reserve1Txt': 'Record 3, reserveveld 1',
  'moneyIn.voucher.rec4Reserve1Txt': 'Record 4, reserveveld 1',
  'moneyIn.voucher.recTypeId': 'Recordtype-ID',
  'moneyIn.voucher.receiverId': 'Ontvanger-ID',
  'moneyIn.voucher.receiverPBSNumber': 'PBS-nummer van ontvanger',
  'moneyIn.voucher.receivingAccount': 'Ontvangende rekening',
  'moneyIn.voucher.receivingCompany': 'Ontvangende maatschappij',
  'moneyIn.voucher.receivingCompanyId': 'Ontvangende maatschappij-ID',
  'moneyIn.voucher.receivingCompanyType': 'Type ontvangende maatschappij',
  'moneyIn.voucher.receivingDate': 'Ontvangstdatum',
  'moneyIn.voucher.receivingFundId': 'Ontvangend fonds-ID',
  'moneyIn.voucher.recipientAccountId': 'Ontvangerrekening-ID',
  'moneyIn.voucher.recipientCustomerId': 'Ontvangerklant-ID',
  'moneyIn.voucher.recipientOwnDepartmentId': 'Eigen afdeling-ID van ontvanger',
  'moneyIn.voucher.reconcileInfo': 'Informatie reconciliatie',
  'moneyIn.voucher.reconcileNote': 'Afstemmingsnotitie',
  'moneyIn.voucher.reconcileValueDate': 'Afstemmingsvalutadatum',
  'moneyIn.voucher.reconciledPaymentDate': 'Afgestemde betaaldatum',
  'moneyIn.voucher.recurring': 'Terugkerend',
  'moneyIn.voucher.reductionDueToForeignTax':
    'Vermindering door buitenlandse belasting',
  'moneyIn.voucher.reference': 'Referentie',
  'moneyIn.voucher.regulationType': 'Aanpassingstype',
  'moneyIn.voucher.relatedLegalEntityId': 'Gerelateerde juridische entiteit-ID',
  'moneyIn.voucher.relatedPersonId': 'Gerelateerde persoon-ID',
  'moneyIn.voucher.relationshipId': 'Relatie-ID',
  'moneyIn.voucher.relationshipNumber': 'Relatienummer',
  'moneyIn.voucher.remark': 'Opmerking',
  'moneyIn.voucher.remarkFreeText': 'Opmerking in vrije tekst',
  'moneyIn.voucher.remunerationPeriod': 'Loonperiode',
  'moneyIn.voucher.remunerationPeriodMetrics': 'Loonperiodestatistieken',
  'moneyIn.voucher.repurchase': 'Terugkoop',
  'moneyIn.voucher.repurchaseClause': 'Terugkoopclausule',
  'moneyIn.voucher.repurchaseClauseText': 'Tekst van terugkoopclausule',
  'moneyIn.voucher.requestDate': 'Aanvraagdatum',
  'moneyIn.voucher.requestedDueDate': 'Gewenste vervaldatum',
  'moneyIn.voucher.resignationDate': 'Datum uitdiensttreding',
  'moneyIn.voucher.responseDateTime': 'Antwoordtijdstip',
  'moneyIn.voucher.retrievalReqNbr': 'Nummer informatieverzoek',
  'moneyIn.voucher.retrievedEmploymentTermsAmount':
    'Opgehaald arbeidsvoorwaardenbedrag',
  'moneyIn.voucher.returnAutomatically': 'Automatisch retourneren',
  'moneyIn.voucher.returnInformation': 'Terugbetalingsgegevens',
  'moneyIn.voucher.returnPaymentInfos': 'Gegevens over retourbetaling',
  'moneyIn.voucher.returnPaymentInvoiceId': 'Terugbetalingsfactuur-ID',
  'moneyIn.voucher.returnReason': 'Reden voor retournering',
  'moneyIn.voucher.returnedPaymentPayableId':
    'Uitbetaling-ID van geretourneerde betaling',
  'moneyIn.voucher.reversalIndicator': 'Indicatie terugboeking',
  'moneyIn.voucher.routingSource': 'Routeringsbron',
  'moneyIn.voucher.routingTarget': 'Routeringsdoel',
  'moneyIn.voucher.salary': 'Salaris',
  'moneyIn.voucher.salaryDetails': 'Salarisgegevens',
  'moneyIn.voucher.salaryFromDate': 'Salaris vanaf datum',
  'moneyIn.voucher.salaryInArrears': 'Salaris in arrears',
  'moneyIn.voucher.salaryInPeriod': 'Salaris in periode',
  'moneyIn.voucher.salaryInformation': 'Salarisgegevens',
  'moneyIn.voucher.salaryLastChangedDate': 'Datum van laatste salariswijziging',
  'moneyIn.voucher.salaryLevel': 'Salarisniveau',
  'moneyIn.voucher.salaryPartTimePct': 'Salaris parttime percentage',
  'moneyIn.voucher.salaryPeriodCancelled': 'Salarisperiode geannuleerd',
  'moneyIn.voucher.salaryPeriodEnd': 'Einde salaris periode',
  'moneyIn.voucher.salaryPeriodStart': 'Start salaris periode',
  'moneyIn.voucher.salaryToDate': 'Salaris tot datum',
  'moneyIn.voucher.salaryType': 'Salaristype',
  'moneyIn.voucher.schemeDatas': 'Regelingsgegevens',
  'moneyIn.voucher.schemeId': 'Regeling-ID',
  'moneyIn.voucher.schemeVariant': 'Regelingsvariant',
  'moneyIn.voucher.schemeWage': 'Regelingsloon',
  'moneyIn.voucher.sectionNumber': 'Sectienummer',
  'moneyIn.voucher.sector': 'Sector',
  'moneyIn.voucher.sectors': 'Sectoren',
  'moneyIn.voucher.senderAccount': 'Rekening van afzender',
  'moneyIn.voucher.senderAccountNumber': 'Rekeningnummer van afzender',
  'moneyIn.voucher.senderCVR': 'CVR-nummer van afzender',
  'moneyIn.voucher.senderCustomerRef': 'Klantreferentie van afzender',
  'moneyIn.voucher.seniorityFromDate': 'Senioriteitsdatum',
  'moneyIn.voucher.sentDateTime': 'Verzendtijdstip',
  'moneyIn.voucher.sequence': 'Volgorde',
  'moneyIn.voucher.sequenceNumber': 'Volgnummer',
  'moneyIn.voucher.settFkMedlemdsNr': 'Lidmaatschapsnummer (Sett FK)',
  'moneyIn.voucher.settFkMedlemsNr': 'Verrekeningslidnummer (FK)',
  'moneyIn.voucher.settleDate': 'Verrekeningsdatum',
  'moneyIn.voucher.settlementFraction': 'Verrekeningsfractie',
  'moneyIn.voucher.severity': 'Ernst',
  'moneyIn.voucher.signingDate': 'Ondertekeningsdatum',
  'moneyIn.voucher.skipFurtherAutoCorrection':
    'Verdere automatische correctie overslaan',
  'moneyIn.voucher.sourceRef': 'Bronreferentie',
  'moneyIn.voucher.sourceReference': 'Bronreferentie',
  'moneyIn.voucher.spec': 'Specificatie',
  'moneyIn.voucher.specialCircumstances': 'Bijzondere omstandigheden',
  'moneyIn.voucher.specialPaymentRules': 'Bijzondere betalingsregels',
  'moneyIn.voucher.specificationCreationDate': 'Aanmaakdatum van specificatie',
  'moneyIn.voucher.specificationEndDate': 'Einddatum specificatie',
  'moneyIn.voucher.specificationLineId': 'Specificatieregel-ID',
  'moneyIn.voucher.specificationNumber': 'Specificatienummer',
  'moneyIn.voucher.specificationStartDate': 'Begindatum specificatie',
  'moneyIn.voucher.specifiedAmount': 'Gespecificeerd bedrag',
  'moneyIn.voucher.spouseIdentity': 'Identiteit van echtgenoot',
  'moneyIn.voucher.spousePension': 'Partnerpensioen',
  'moneyIn.voucher.spousePensionAmount': 'Bedrag partnerpensioen',
  'moneyIn.voucher.spousePensionDate': 'Datum partnerpensioen',
  'moneyIn.voucher.spousePensionPeriod': 'Periode partnerpensioen',
  'moneyIn.voucher.stamp': 'Tijdstempel',
  'moneyIn.voucher.startDate': 'Begindatum',
  'moneyIn.voucher.startDateIncomePeriod': 'Begindatum inkomstenperiode',
  'moneyIn.voucher.stoppingPensionPBL15A': 'Eindigend pensioen (PBL § 15 A)',
  'moneyIn.voucher.subIssues': 'Onderliggende problemen',
  'moneyIn.voucher.sumPaymentTaxCode1and2TransferYear':
    'Totale betalingen, belastingcode 1 en 2, overdrachtsjaar',
  'moneyIn.voucher.sumPaymentTaxfreeAgeSchemeTransferYear':
    'Totale betalingen aan belastingvrije ouderdomsspaarregeling in overdrachtsjaar',
  'moneyIn.voucher.sumReturnsAverageInterestRate':
    'Totaal rendement met gemiddelde rente',
  'moneyIn.voucher.sumReturnsMarketInterestRate':
    'Totaal rendement met marktrente',
  'moneyIn.voucher.sumReturnsOngoingAgeScheme_Bank':
    'Totaal rendement van lopende ouderdomsspaarregeling (bank)',
  'moneyIn.voucher.sumReturnsTransferYear':
    'Totaal rendement in overdrachtsjaar',
  'moneyIn.voucher.sumReturnsTransferYearPension':
    'Totaal pensioenrendement in overdrachtsjaar',
  'moneyIn.voucher.sumStopPaymentsAnnuityInstalment':
    'Totale tijdelijke lijfrente- en termijnuitkeringen',
  'moneyIn.voucher.sumTaxfreeSinglePayment':
    'Totale belastingvrije eenmalige uitkering',
  'moneyIn.voucher.summaryDate': 'Overzichtsdatum',
  'moneyIn.voucher.supplementalAmountEntity': 'Aanvullende bedragseenheid',
  'moneyIn.voucher.supplierId': 'Leverancier-ID',
  'moneyIn.voucher.suspensionDate': 'Schorsingsdatum',
  'moneyIn.voucher.suspensionReason': 'Schorsingsreden',
  'moneyIn.voucher.systemCode': 'Systeemcode',
  'moneyIn.voucher.table.otherDetails': 'Overige gegevens',
  'moneyIn.voucher.table.value': 'Waarde',
  'moneyIn.voucher.targetId': 'Doel-ID',
  'moneyIn.voucher.taskNumber': 'Taaknummer',
  'moneyIn.voucher.taxCode1ValuePayedToCustomer':
    'Bedrag uitbetaald aan klant, belastingcode 1',
  'moneyIn.voucher.taxInformation': 'Belastinggegevens',
  'moneyIn.voucher.telephoneNumber': 'Telefoonnummer',
  'moneyIn.voucher.template': 'Sjabloon',
  'moneyIn.voucher.tenantId': 'Tenant-ID',
  'moneyIn.voucher.terminalOpeMeNo': 'Terminaloperatornummer',
  'moneyIn.voucher.timeSlotEndDate': 'Einddatum tijdvak',
  'moneyIn.voucher.timeSlotStartDate': 'Begindatum tijdvak',
  'moneyIn.voucher.toDate': 'Tot datum',
  'moneyIn.voucher.toDueDate': 'Tot vervaldatum',
  'moneyIn.voucher.totalAmount': 'Totaal bedrag',
  'moneyIn.voucher.totalAmountInFile': 'Totaalbedrag in bestand',
  'moneyIn.voucher.totalContributionPercentage': 'Totaal bijdragepercentage',
  'moneyIn.voucher.totalNoOfContributions': 'Totaal aantal bijdragen',
  'moneyIn.voucher.traceId': 'Traceer-ID',
  'moneyIn.voucher.transTypeCode': 'Transactietypecode',
  'moneyIn.voucher.transactionType': 'Transactietype',
  'moneyIn.voucher.transactions': 'Transacties',
  'moneyIn.voucher.transactionsNo': 'Aantal transacties',
  'moneyIn.voucher.transferAgeSchemeTaxFree':
    'Overdracht van belastingvrije ouderdomsspaarregeling',
  'moneyIn.voucher.transferData': 'Overdrachtsgegevens',
  'moneyIn.voucher.transferDataNumber': 'Overdrachtsgegevensnummer',
  'moneyIn.voucher.transferDate': 'Datum van overdracht',
  'moneyIn.voucher.transferOngoingInstalmentPension':
    'Overdracht van lopend termijnpensioen',
  'moneyIn.voucher.transferStoppingOngoingAnnuity':
    'Overdracht van lopende tijdelijke lijfrente',
  'moneyIn.voucher.transferTaxCode1': 'Overdracht, belastingcode 1',
  'moneyIn.voucher.transferTaxCode2': 'Overdracht, belastingcode 2',
  'moneyIn.voucher.transferTaxCode3': 'Overdracht, belastingcode 3',
  'moneyIn.voucher.transferredIn': 'Inkomend overgedragen',
  'moneyIn.voucher.transferringFundId': 'Overdragend fonds',
  'moneyIn.voucher.twkInvoice': 'TWK-factuur',
  'moneyIn.voucher.txtRecvAcctStm': 'Tekst op rekeningafschrift van ontvanger',
  'moneyIn.voucher.typeOfPension': 'Pensioentype',
  'moneyIn.voucher.typeOfTransfer': 'Overdrachtstype',
  'moneyIn.voucher.unexpectedInvoicePaymentType':
    'Type onverwachte factuurbetaling',
  'moneyIn.voucher.uniqueNtryRef': 'Unieke boekingsreferentie',
  'moneyIn.voucher.uniqueStmtId': 'Unieke rekeningafschrift-ID',
  'moneyIn.voucher.unparseableRecord04': 'Record 04 kon niet worden verwerkt',
  'moneyIn.voucher.unparseableValues': 'Waarden konden niet worden verwerkt',
  'moneyIn.voucher.unrelatedPaymentType': 'Niet gerelateerd betalings type',
  'moneyIn.voucher.unusedNegativePALOngoingAgeScheme_Bank':
    'Onbenutte negatieve PAL-belasting, lopende ouderdomsspaarregeling (bank)',
  'moneyIn.voucher.upaDeclarationType': 'UPA-aangiftetype',
  'moneyIn.voucher.upaIncomeRelation': 'UPA-inkomstenverhouding',
  'moneyIn.voucher.upaIncomeRelationVoucherRef':
    'Referentie naar UPA-inkomstenverhoudingboekstuk',
  'moneyIn.voucher.upaProcessingResult': 'UPA-verwerkingsresultaat',
  'moneyIn.voucher.upaSchemeId': 'UPA-regeling-ID',
  'moneyIn.voucher.upaTimeSlotDeclarationType': 'UPA-tijdvakaangiftetype',
  'moneyIn.voucher.upaTimeSlotType': 'UPA-tijdvaktype',
  'moneyIn.voucher.upaXmlSchemaVersion': 'UPA-XML-schemaversie',
  'moneyIn.voucher.upcomingReturnPaymentPostingId':
    'Komende terugbetalingsboekings-ID',
  'moneyIn.voucher.usedDefaultEmployerAgreementPolicy':
    'Standaardpolis van werkgeversovereenkomst gebruikt',
  'moneyIn.voucher.usedSoftwarePackage': 'Gebruikt softwarepakket',
  'moneyIn.voucher.userId': 'Gebruikers-ID',
  'moneyIn.voucher.usesProjectedData': 'Gebruikt geprojecteerde gegevens',
  'moneyIn.voucher.validationErrorIssues': 'Validatiefouten',
  'moneyIn.voucher.validationResult': 'Validatieresultaat',
  'moneyIn.voucher.value79Before72': 'Waarde 79 vóór 72',
  'moneyIn.voucher.value79From72To79': 'Waarde 79 van 72 tot 79',
  'moneyIn.voucher.value82': 'Waarde 82',
  'moneyIn.voucher.valueFromPayload': 'Waarde uit berichtinhoud',
  'moneyIn.voucher.valueTransferId': 'Waardeoverdracht-ID',
  'moneyIn.voucher.valueTransferStatement': 'Waardeoverdrachtsopgave',
  'moneyIn.voucher.valueTransferType': 'Waardeoverdracht type',
  'moneyIn.voucher.valueTransfered': 'Overgedragen waarde',
  'moneyIn.voucher.voluntaryContributionPlacement':
    'Plaatsing van vrijwillige bijdrage',
  'moneyIn.voucher.voluntaryContributionPolicyId':
    'Polis-ID voor vrijwillige bijdrage',
  'moneyIn.voucher.voluntaryContributionType': 'Type vrijwillige bijdrage',
  'moneyIn.voucher.voucherFieldName': 'Boekstukveldnaam',
  'moneyIn.voucher.voucherVersionSequenceNumber':
    'Volgnummer van boekstukversie',
  'moneyIn.voucher.wageFromOvertime': 'Overwerkloon',
  'moneyIn.voucher.wageTaxTableCode': 'Code loonbelastingtabel',
  'moneyIn.voucher.wagesLBPH': 'LBPH-loon',
  'moneyIn.voucher.wagesSV': 'SV-loon',
  'moneyIn.voucher.wagesTaxedSpecialRenumerationTable':
    'Loon belast volgens tabel bijzondere beloningen',
  'moneyIn.voucher.warningCodes': 'Waarschuwingscodes',
  'moneyIn.voucher.warnings': 'Waarschuwingen',
  'moneyIn.voucher.widowIdentity': 'Identiteit van weduwe',
  'moneyIn.voucher.withdrawPaymentCommandId':
    'Opdracht-ID voor intrekking van betaling',
  'moneyIn.voucher.withdrawalDate': 'Intrekkingsdatum',
  'moneyIn.voucher.withdrawnPenaltyId': 'Ingetrokken boete-ID',
  'moneyIn.voucher.withholdPALTax': 'PAL-belasting inhouden',
  'moneyIn.voucher.withholdPALTaxTransferYear':
    'PAL-belasting inhouden in overdrachtsjaar',
  'moneyIn.voucher.workHours': 'Werkuren',
  'moneyIn.voucher.workHoursInPeriod': 'Werkuren in periode',
  'moneyIn.voucher.workflowRef': 'Workflowreferentie',
  'moneyIn.voucher.writeOffCategory': 'Afschrijving categorie',
  'moneyIn.voucher.writeOffType': 'Afschrijving type',
  'moneyIn.voucher.yearOldestUnusedPALTax':
    'Jaar van oudste ongebruikte PAL-belasting',
} as const satisfies Record<keyof typeof fallbackAutoGenerated, string>
